import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { styled, alpha } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import CountUp from 'react-countup';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import { FaSearch, FaRegSmile, FaSmile } from "react-icons/fa";
import { CiFaceSmile } from "react-icons/ci";
import { BsEmojiSmile } from "react-icons/bs";
import { BsArrowRight } from "react-icons/bs";
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import iconlogo from './img/Vector.png'
import interfaceicon from './img/interfaceicon.png'
import animatedicon from './img/animated.png'
import camera from './img/cameraanimation.gif'
import bee1 from './img/bee_1 1.png'
import bee2 from './img/bee_2.png'
import bee3 from './img/bee_3.png'
import boy from './img/phone-carry 1.png'
import football from './img/Football.png'
import happy from './img/happy.png'
import sad from './img/sad.png'
import lineleft from './img/line left.png'
import lineright from './img/line right.png'
import AOS from 'aos';
import 'aos/dist/aos.css';
import {
    BrowserRouter as Router,
    Switch,
    Route,

} from "react-router-dom";
import axios from 'axios';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(3),
        width: 'auto',
    },
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
}));
const card1 = (
    <React.Fragment>

        <img src={iconlogo} className='block' alt="Icon Logo" />

    </React.Fragment>
);
const card2 = (
    <React.Fragment>

        <img src={interfaceicon} className='block' alt="Interface Icon" />

    </React.Fragment>
);
const card3 = (
    <React.Fragment>
        <img src={animatedicon} className='block' alt="Animated Icon" />
    </React.Fragment>
);


function WebBody() {
   

    const [searchValue, setSearchValue] = useState('');
    const [metaDescription, setMetaDescription] = useState('Search and discover icons for your website');
    const [metaKeywords, setMetaKeywords] = useState('icons, web design, UI/UX, search icons');

    let history = useHistory()

    const handleSearchChange = (event) => {
        setSearchValue(event.target.value);
        // Update meta description based on search
        setMetaDescription(`Search results for ${event.target.value} icons`);
        // Update meta keywords based on search
        setMetaKeywords(`${event.target.value}, icons, web design, UI/UX`);
    };

    useEffect(() => {
        Gotoup()
        // Set initial meta tags
        updateMetaTags()
    }, [])

    const Gotoup = () => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" })
    }

    const updateMetaTags = () => {
        // Update meta tags for SEO
        const descriptionMeta = document.querySelector('meta[name="description"]');
        const keywordsMeta = document.querySelector('meta[name="keywords"]');
        
        if (descriptionMeta) {
            descriptionMeta.setAttribute("content", metaDescription);
        } else {
            const newDescriptionMeta = document.createElement('meta');
            newDescriptionMeta.name = "description";
            newDescriptionMeta.content = metaDescription;
            document.head.appendChild(newDescriptionMeta);
        }
        
        if (keywordsMeta) {
            keywordsMeta.setAttribute("content", metaKeywords);
        } else {
            const newKeywordsMeta = document.createElement('meta');
            newKeywordsMeta.name = "keywords";
            newKeywordsMeta.content = metaKeywords;
            document.head.appendChild(newKeywordsMeta);
        }
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearchSubmit();
        }
    };

    const handleSearchSubmit = () => {
        updateMetaTags();
        history.push({
            pathname: '/search-icon',
            state: { searchValue: searchValue }
        });
    };

    return (
        <>
            <Helmet>
                <title>IconGrid - Free Icons for Web Design and UI/UX</title>
                <meta name="description" content={metaDescription} />
                <meta name="keywords" content={metaKeywords} />
                <meta property="og:title" content="IconGrid - Free Icons for Web Design and UI/UX" />
                <meta property="og:description" content={metaDescription} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://icongrid.com" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="IconGrid - Free Icons for Web Design and UI/UX" />
                <meta name="twitter:description" content={metaDescription} />
            </Helmet>
            <Box sx={{ width: '100%', paddingTop: '55px' }}>
                <Box className="home-hero" sx={{ backgroundColor: "#ffffff", paddingTop: '55px', height: '650px', width: '100%', zIndex: 9 }}>

                    <Container maxWidth="xl">

                        <Box sx={{ position: 'relative'/*display: { xs: 'none', md: 'flex' }*/ }}>
                            <Grid container xs={12} sx={{ justifyContent: 'center' }}>
                                <Stack spacing={0} direction="row" alignItems="center" sx={{ width: "100%" }}>
                                    <Grid item xs={12} sx={{
                                        display: 'flex', width: '70%', flexDirection: 'column', color: '#272727', justifyContent: 'center', marginTop: { xs: '50px', sm: '120px' }, textAlign: 'center', lineHeight: '1',
                                        fontWeight: "700", zIndex: 9, fontSize: { xs: '22px', sm: '32px', md: '45px' }
                                    }}>
                                        {/* data-aos="zoom-in" data-aos-offset="0" */}
                                        <h1 style={{fontSize: 'inherit', fontWeight: 'inherit', margin: 0}}>
                                            Take the hassle out of <font color="#ffbc06">icons</font><br/> in your website.
                                        </h1>
                                    </Grid>

                                </Stack>
                                <Stack spacing={1} direction="row" alignItems="center" sx={{ width: { xs: '80%', sm: "48%" } }}>
                                    <Grid item xs={12} sx={{
                                        color: '#272727', textAlign: 'center', paddingTop: '33px',
                                        alignItems: 'end', zIndex: 9, fontSize: { xs: '12px', sm: '12px', md: '14px' }
                                    }}>
                                        <p>"At <b> <font fontSize="16px">IconGrid,</font></b> we believe in the power of connection to transform lives and shape futures. Join our global community to share ideas, collaborate on projects, and build meaningful relationships. Together, let's turn dreams into reality."</p>
                                    </Grid>
                                </Stack>
                            </Grid>
                        </Box>
                    </Container>
                    <Box sx={{ flexGrow: 1 }}>
                        <Toolbar sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Grid sx={{ width: { xs: '90%', sm: '50%' }, paddingTop: '33px' }}>
                                <Search sx={{ backgroundColor: '#fff0', border: '1px solid #272727', margin: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Box className="icon-serch" sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Box sx={{ paddingLeft: '10px', paddingTop: '5px' }}>
                                            <FaSearch fontSize={'20px'} aria-label="Search icon" />
                                        </Box>
                                        <StyledInputBase
                                            placeholder="Search…"
                                            inputProps={{ 'aria-label': 'search for icons' }}
                                            value={searchValue}
                                            onChange={handleSearchChange}
                                            onKeyPress={handleKeyPress}
                                        />
                                    </Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: '7px' }}>
                                        <Box sx={{ border: '1px solid #FFBC06', backgroundColor: '#FFBC06', borderRadius: '5px', padding: '0px 10px', cursor: 'pointer' }} onClick={handleSearchSubmit}>
                                            <Link to={{ pathname: "/search-icon", state: { searchValue: searchValue } }} aria-label="Go to search results">
                                                Go
                                            </Link>
                                        </Box>
                                    </Box>
                                </Search>
                            </Grid>
                        </Toolbar>
                    </Box>
                </Box>

                <Box sx={{ marginTop: '0px', backgroundColor: '#272727' }}>
                    <Grid container padding={'24px'} sx={{ justifyContent: 'space-around' }}>
                        <Grid item md={3} sm={6} xs={12} sx={{}}  >
                            <Link to="/icons" aria-label="View all icons">
                                <Box sx={{ display: 'flex', justifyContent: 'center', padding: '10px 0px 20px 0px' }}>
                                    {card1}
                                </Box>
                                <Box fontWeight={600} fontSize={'30px'} className='center c-white'>
                                    <CountUp delay={2} end={200} />+
                                </Box>
                                <CardActions className='c-white' sx={{ display: 'flex', justifyContent: 'center', paddingBottom: '5px' }}>
                                    <Button className='center c-white' size="large">Icons</Button>
                                </CardActions>
                                <Typography textAlign={'center'} className='c-white' fontSize={'15px'}>
                                    A comprehensive repository of freely available icons suitable for various projects.
                                </Typography>
                            </Link>
                        </Grid>
                        <Grid item md={3} sm={6} xs={12}>
                            <Link to="/interface-icons" aria-label="View interface icons">
                                <Box sx={{ display: 'flex', justifyContent: 'center', padding: '10px 0px 20px 0px' }}>
                                    {card2}
                                </Box>
                                <Box fontWeight={600} fontSize={'30px'} className='center c-white'>
                                    <CountUp delay={2} end={200} />+

                                </Box>
                                <CardActions className='c-white' sx={{ display: 'flex', justifyContent: 'center', paddingBottom: '5px' }}>
                                    <Button className='center c-white' size="large">Interface Icons</Button>
                                </CardActions>
                                <Typography className='center c-white' textAlign={'center'} color={'#777'} fontSize={'15px'}>
                                    Icons crafted specifically for your user interfaces.
                                </Typography>
                            </Link>
                        </Grid>
                        <Grid item md={3} sm={6} xs={12}>
                            <Link to="/animated-icons" aria-label="View animated icons">
                                <Box sx={{ display: 'flex', justifyContent: 'center', padding: '10px 0px 20px 0px' }}>
                                    {card3}
                                </Box>
                                <Box fontWeight={600} fontSize={'30px'} className='center c-white'>
                                    <CountUp delay={2} end={200} />+

                                </Box>
                                <CardActions className='c-white' sx={{ display: 'flex', justifyContent: 'center', paddingBottom: '5px' }}>
                                    <Button className='center c-white' size="large">Animated Icons</Button>
                                </CardActions>
                                <Typography className='c-white center' textAlign={'center'} color={'#777'} fontSize={'15px'}>
                                    Animated icons to enhance the visual appeal of your projects.
                                </Typography>
                            </Link>
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ marginTop: '70px', padding: '0px 24px' }}>
                    <Container maxWidth="xl">
                        <Grid xs={12}>
                            <Typography component="h1" sx={{ fontSize: { xs: '18px', sm: '30px' }, fontFamily: 'Degular,Inter,Helvetica Neue,Helvetica,Arial,sans-serif', color: '#424242;', fontWeight: 600, textAlign: 'center' }}>
                                GICONS: The Ultimate Collection of Free SVG User Interface Icons
                            </Typography>
                            <Typography component="h2" sx={{ color: '#777', fontSize: { xs: '12px', sm: '16px' }, textAlign: 'center', marginTop: '10px' }}>
                                Discover our vast library of over 24,300 free UI icons in 9 unique styles - perfect for web designers, developers, and digital creators.
                            </Typography>
                            <meta name="description" content="GICONS offers 24,300+ free SVG UI icons in 9 styles. Fully customizable for web design, app development, and digital projects." />
                            <meta name="keywords" content="free icons, SVG icons, UI icons, user interface icons, web design, app development, icon library, customizable icons" />
                            <meta property="og:title" content="GICONS: Free SVG User Interface Icons Collection" />
                            <meta property="og:description" content="Explore 24,300+ free, customizable UI icons in 9 styles for your web and app projects." />
                            <meta name="twitter:card" content="summary_large_image" />
                            <meta name="twitter:title" content="GICONS: Free SVG User Interface Icons" />
                            <meta name="twitter:description" content="24,300+ free, customizable UI icons for web and app design." />
                        </Grid>
                    </Container>

                    <Container maxWidth="xl" sx={{ marginTop: '35px' }}>
                        <Grid container xs={12} className='center'>
                            <Box padding={'0px 8px'} margin={'20px 0px'}>
                                <Grid sx={{ borderRadius: '20px', overflow: 'hidden', width: '269px', border: '1px solid #272727' }}>
                                    <Box sx={{ height: '86px', backgroundColor: '#FFE08A' }}>
                                    </Box>
                                    <Box className='center'>
                                        <Box className='center' sx={{ marginTop: '-37px', height: '73px', width: '73px', backgroundColor: '#FFC62D', alignItems: 'center', borderRadius: '50%' }}>
                                            <FaRegSmile fontSize={'35px'} />
                                        </Box>
                                    </Box>
                                    <Box className='center' fontSize={'18px'} padding={'20px'}>
                                        Regular
                                    </Box>
                                    <Box className='center' padding={'0px 28px'} textAlign={"center"}>
                                        "Explore our free regular icons for versatile design solutions. From simple outlines to detailed illustrations, find the perfect icon to enhance your projects effortlessly."
                                    </Box>
                                    <Box className='center' sx={{ padding: '20px 28px', textAlign: 'center' }} >
                                        <Link to="/most-downloads">
                                            <Box sx={{ border: '1px solid #ffbc06', padding: '5px 60px', borderRadius: '7px', backgroundColor: '#FFE08A' }}>Explore</Box>
                                        </Link>
                                    </Box>
                                    <meta name="description" content="Discover our collection of free regular icons for versatile design solutions. Perfect for enhancing your projects with simple outlines to detailed illustrations." />
                                    <meta name="keywords" content="regular icons, free icons, design solutions, project enhancement, versatile icons" />
                                    <meta property="og:title" content="Regular Icons - Free Versatile Design Solutions" />
                                    <meta property="og:description" content="Explore our free regular icons for versatile design solutions. Find the perfect icon to enhance your projects effortlessly." />
                                    <meta name="twitter:card" content="summary" />
                                    <meta name="twitter:title" content="Regular Icons - Free Versatile Design Solutions" />
                                    <meta name="twitter:description" content="Discover free regular icons for versatile design solutions. Enhance your projects with our collection." />
                                </Grid>
                            </Box >
                            <Box padding={'0px 8px'} margin={'20px 0px'}>
                                <Grid sx={{ borderRadius: '20px', overflow: 'hidden', width: '269px', border: '1px solid #272727' }}>
                                    <Box sx={{ height: '86px', backgroundColor: '#AEDBFF' }}>
                                    </Box>
                                    <Box className='center'>
                                        <Box className='center' sx={{ marginTop: '-37px', height: '73px', width: '73px', backgroundColor: '#74C0FC', alignItems: 'center', borderRadius: '50%' }}>
                                            <FaSmile fontSize={'35px'} />
                                        </Box>
                                    </Box>
                                    <Box className='center' fontSize={'18px'} padding={'20px'}>
                                        Bold
                                    </Box>
                                    <Box className='center' padding={'0px 28px'} textAlign={"center"}>
                                        "Explore our free bold icons for versatile design solutions. From simple outlines to detailed illustrations, find the perfect icon to enhance your projects effortlessly."                                    </Box>
                                    <Box className='center' sx={{ padding: '20px 28px', textAlign: 'center' }} >
                                        <Link to="/most-downloads">
                                            <Box sx={{ border: '1px solid #AEDBFF', padding: '5px 60px', borderRadius: '7px', backgroundColor: '#AEDBFF' }}>Explore</Box>
                                        </Link>
                                    </Box>
                                    <meta name="description" content="Discover our collection of free bold icons for versatile design solutions. Perfect for enhancing your projects with impactful and eye-catching illustrations." />
                                    <meta name="keywords" content="bold icons, free icons, design solutions, project enhancement, impactful icons" />
                                    <meta property="og:title" content="Bold Icons - Free Impactful Design Solutions" />
                                    <meta property="og:description" content="Explore our free bold icons for versatile design solutions. Find the perfect icon to make your projects stand out effortlessly." />
                                    <meta name="twitter:card" content="summary" />
                                    <meta name="twitter:title" content="Bold Icons - Free Impactful Design Solutions" />
                                    <meta name="twitter:description" content="Discover free bold icons for versatile design solutions. Make your projects stand out with our collection." />
                                </Grid>
                            </Box>
                            <Box padding={'0px 8px'} margin={'20px 0px'}>
                                <Grid sx={{ borderRadius: '20px', overflow: 'hidden', width: '269px', border: '1px solid #272727' }}>
                                    <Box sx={{ height: '86px', backgroundColor: '#CDBBFF' }}>
                                    </Box>
                                    <Box className='center'>
                                        <Box className='center' sx={{ marginTop: '-37px', height: '73px', width: '73px', backgroundColor: '#B197FC', alignItems: 'center', borderRadius: '50%' }}>
                                            <CiFaceSmile fontSize={'35px'} />
                                        </Box>

                                    </Box>
                                    <Box className='center' fontSize={'18px'} padding={'20px'}>
                                        Thin
                                    </Box>
                                    <Box className='center' padding={'0px 28px'} textAlign={"center"}>
                                        "Explore our free thin icons for versatile design solutions. From simple outlines to detailed illustrations, find the perfect icon to enhance your projects effortlessly."
                                    </Box>
                                    <Box className='center' sx={{ padding: '20px 28px', textAlign: 'center' }} >
                                        <Link to="/most-downloads">
                                            <Box sx={{ border: '1px solid #CDBBFF', padding: '5px 60px', borderRadius: '7px', backgroundColor: '#CDBBFF' }}>Explore</Box>
                                        </Link>
                                    </Box>
                                    <meta name="description" content="Discover our collection of free thin icons for elegant design solutions. Perfect for enhancing your projects with subtle and refined illustrations." />
                                    <meta name="keywords" content="thin icons, free icons, design solutions, project enhancement, elegant icons" />
                                    <meta property="og:title" content="Thin Icons - Free Elegant Design Solutions" />
                                    <meta property="og:description" content="Explore our free thin icons for versatile design solutions. Find the perfect icon to add a touch of elegance to your projects effortlessly." />
                                    <meta name="twitter:card" content="summary" />
                                    <meta name="twitter:title" content="Thin Icons - Free Elegant Design Solutions" />
                                    <meta name="twitter:description" content="Discover free thin icons for versatile design solutions. Add a touch of elegance to your projects with our collection." />
                                </Grid>
                            </Box>
                            <Box padding={'0px 8px'} margin={'20px 0px'}>
                                <Grid sx={{ borderRadius: '20px', overflow: 'hidden', width: '269px', border: '1px solid #272727' }}>
                                    <Box sx={{ height: '86px', backgroundColor: '#94FFDE' }}>
                                    </Box>
                                    <Box className='center'>
                                        <Box className='center' sx={{ marginTop: '-37px', height: '73px', width: '73px', backgroundColor: '#63E6BE', alignItems: 'center', borderRadius: '50%' }}>
                                            <BsEmojiSmile fontSize={'35px'} />
                                        </Box>

                                    </Box>
                                    <Box className='center' fontSize={'18px'} padding={'20px'}>
                                        Solid
                                    </Box>
                                    <Box className='center' padding={'0px 28px'} textAlign={"center"}>
                                        "Explore our free solid icons for versatile design solutions. From simple outlines to detailed illustrations, find the perfect icon to enhance your projects effortlessly."
                                    </Box>
                                    <Box className='center' sx={{ padding: '20px 28px', textAlign: 'center' }} >
                                        <Link to="/most-downloads">
                                            <Box sx={{ border: '1px solid #94FFDE', padding: '5px 60px', borderRadius: '7px', backgroundColor: '#94FFDE' }}>Explore</Box>
                                        </Link>
                                    </Box>
                                    <meta name="description" content="Discover our collection of free solid icons for bold design solutions. Perfect for enhancing your projects with strong and impactful illustrations." />
                                    <meta name="keywords" content="solid icons, free icons, design solutions, project enhancement, bold icons" />
                                    <meta property="og:title" content="Solid Icons - Free Bold Design Solutions" />
                                    <meta property="og:description" content="Explore our free solid icons for versatile design solutions. Find the perfect icon to add a bold statement to your projects effortlessly." />
                                    <meta name="twitter:card" content="summary" />
                                    <meta name="twitter:title" content="Solid Icons - Free Bold Design Solutions" />
                                    <meta name="twitter:description" content="Discover free solid icons for versatile design solutions. Add a bold statement to your projects with our collection." />
                                </Grid>
                            </Box>
                        </Grid>

                    </Container>
                </Box>

                <Box sx={{ marginTop: '70px' }}>
                    <Container maxWidth="xl" sx={{ backgroundColor: '#CDBBFF' }}>
                        <Grid container xs={12}>
                            <Box sx={{ flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center', display: 'flex' }}>
                                <Grid flexDirection={'column'} position={'relative'} xs={12} md={6}    >
                                    <Box className='center' sx={{ alignItems: 'center', color: '#703DFF', flexDirection: 'column', fontSize: { xs: '40px', sm: '60px', md: '60px', lg: '70px' }, paddingTop: '55px', fontWeight: '700', fontFamily: "Rammetto One, sans-serif" }}>
                                        Animated
                                    </Box>
                                    <Box sx={{ marginTop: '-37px' }}>
                                        <Box className='center gif' sx={{ alignItems: 'center', fontWeight: '700', fontFamily: "Rammetto One, sans-serif" }}>
                                            <img src={camera} alt="Animated camera icon" srcSet="" />
                                        </Box>
                                        <Box className='center' sx={{
                                            marginTop: { xs: '-146px', sm: '-268px', md: '-268px', lg: '-282px' },
                                            marginLeft: { xs: 'auto', sm: '65px' },
                                            alignItems: 'center', color: '#fff', fontSize: { xs: '90px', sm: '155px', md: '155px', lg: '171px' }, fontFamily: "Rammetto One, sans-serif"
                                        }}>
                                            Ic&nbsp;&nbsp;&nbsp;ns
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid xs={12} md={6} sx={{ padding: { xs: '10px', sm: '10px', md: '60px' }, display: 'felx', flexDirection: 'column', alignItems: 'center' }}>
                                    <Box sx={{ paddingTop: { sm: '0px', md: '30px' }, fontSize: { xs: '12px', sm: '16px' } }}>
                                        We provide you animated icons through which you can bring your website to life and make it animated. animations plays a vital role in your web page as it can directly enhance the user experience and change their perception of visualizing your brand.
                                    </Box>
                                    <Box sx={{ paddingTop: '20px', fontSize: { xs: '12px', sm: '16px' } }}>
                                        Explore different categories of animated icons with unique creativity to unlock more productivity.
                                    </Box>
                                    <Box sx={{ paddingTop: { xs: '40px', sm: '60px' } }}>
                                        <Box sx={{ borderRadius: '7px', display: 'inline-block', padding: '5px 20px', color: '#fff', backgroundColor: '#703DFF', cursor: 'pointer' }}>
                                            <Link to="/animated-icons">
                                                <Box color={'#fff'}>More..!</Box>
                                            </Link>
                                        </Box>
                                    </Box>
                                </Grid>
                            </Box>
                        </Grid>
                    </Container>
                </Box>
                <meta name="description" content="Discover our collection of animated icons to bring your website to life. Enhance user experience and change brand perception with our unique, creative animations." />
                <meta name="keywords" content="animated icons, website animations, user experience, brand perception, creative icons" />
                <meta property="og:title" content="Animated Icons - Bring Your Website to Life" />
                <meta property="og:description" content="Explore our animated icons to enhance your website's user experience and transform your brand's visual appeal. Unlock creativity and productivity with our diverse icon categories." />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Animated Icons - Elevate Your Website's Visual Appeal" />
                <meta name="twitter:description" content="Discover animated icons that breathe life into your website. Enhance user experience and transform brand perception with our creative, animated illustrations." />


                {/* responsive */}

                <Box className="Hide">
                <Box sx={{display:{xs:'none',md:'block'}, marginTop: '50px', position: 'relative' }}>
                    <Box sx={{ position: 'absolute', top: '52%', zIndex: 9 }}>
                        <img src={lineleft} alt="" srcset="" />
                    </Box>
                    <Box sx={{ position: 'absolute', top: '21%', right: 0, zIndex: 9 }}>
                        <img src={lineright} alt="" srcset="" />
                    </Box>
                    <Container maxWidth="lg" sx={{}}>
                        <Grid xs={12} container>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Grid xs={6}>
                                    <Box sx={{ fontSize: '163px', fontWeight: '600' }}>
                                        make
                                    </Box>
                                </Grid >
                                <Grid xs={6} display={'flex'}>
                                    <Grid xs={3}>
                                        <Box sx={{ fontSize: '70px', marginLeft: '0px', height: '121px', width: '121px', backgroundColor: '#65C67F', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <BsArrowRight />
                                        </Box>
                                    </Grid>
                                    <Grid xs={7}>
                                        <Box>
                                            <label class="switch" id="autoToggle">
                                                <span class="happy"><img width="50%" src={happy} alt="" srcset="" /></span>
                                                <span class="sad"><img width="50%" src={sad} alt="" srcset="" /></span>
                                                <input type="checkbox" class="input" id="toggleCheckbox"></input>
                                                <span class="slider"></span>
                                            </label>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                        <Grid xs={12} marginTop={'-80px'} container position={'relative'}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>

                                <Box sx={{ fontSize: '70px', marginLeft: '25px', height: '121px', width: '121px', backgroundColor: '#FFBC06', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                                </Box>
                                <Box sx={{ fontSize: '160px', marginLeft: '80px', fontWeight: '600' }}>
                                    ur website
                                </Box>
                            </Box>
                            <Box className='blur' sx={{ position: 'relative', height: '43px', top: '98px', left: '10.5%', position: 'absolute', width: '127px' }}>
                                <Box sx={{
                                    height: '6px',
                                    width: '56px',
                                    backgroundColor: 'black',
                                    position: 'absolute',
                                    top: '18px',
                                    left: '39px',
                                    borderRadius: '50px'
                                }}></Box>
                            </Box>
                        </Grid>
                        <Grid xs={12} marginTop={'-80px'} container position={'relative'}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Box marginLeft={'150px'}></Box>
                                <Box
                                    sx={{
                                        height: '121px', width: '121px',
                                        backgroundImage: 'radial-gradient( #F76D42 35%, #5552EC 100%)',
                                        borderRadius: '50%',
                                        marginLeft: '40px'
                                    }}>

                                </Box>
                                <Box
                                    sx={{
                                        height: '121px', width: '121px',
                                        backgroundColor: '#95CCFF',
                                        borderRadius: '50%',
                                        marginLeft: '-65px'
                                    }}>

                                </Box>

                                <Box sx={{ marginLeft: '40px' }}>
                                    <img className='vert-move' src={football} alt="" srcset="" />
                                </Box>
                                <Box sx={{ fontSize: '158px', fontWeight: '600' }}>
                                    lifelike
                                </Box>
                            </Box>

                        </Grid>
                    </Container>
                </Box>
                </Box>

                {/* responsive */}

                <Box sx={{ marginTop: '25px', backgroundColor: '#FFE08A' }}>
                    <Container className='bgIcons' maxWidth="xl" sx={{}}>
                        <Grid container xs={12}>
                            <Grid xs={12} sm={6} sx={{ padding: { xs: '70px 24px 70px 24px', sm: '70px 30px 70px 30px', md: '122px 70px 0px 90px' } }} >
                                <Box sx={{ position: 'relative' }}>
                                    <h1 sx={{ fontSize: '34px', marginBottom: '17px', fontWeight: '500', display: 'inline-block', borderBottom: '3px solid #272727' }}>Our Interface</h1>
                                    <Box sx={{ position: 'absolute', top: { xs: '-55%', sm: '-55%', md: '-52%' }, left: { xs: '54%', sm: '58%', md: '33%' } }}>
                                        <img src={bee1} alt="Decorative bee icon" srcSet="" />
                                    </Box>
                                </Box>
                                <Box>
                                    <Grid xs={12}>
                                        <p sx={{ position: 'relative', fontSize: { xs: '12px', sm: '16px', md: '14px', lg: '16px' } }}>
                                            Our interface is simplified so that our users can navigate through different pages & icons without any problems. Our interface is user-friendly, featuring a clean design for easy navigation. You can browse categories, search for icons, and preview them in different sizes and formats. It's responsive across devices, ensuring a seamless experience. Simplifying the process, you can quickly find and download icons for your projects, whether you're a designer, developer, or enthusiast.
                                        </p>
                                    </Grid>
                                </Box>
                            </Grid>
                            <Grid sm={6}>
                                <Box sx={{ position: 'relative' }}>
                                    <Box className='Nest'>
                                        <Box sx={{ position: 'absolute', bottom: { sm: '23%', md: '23%' }, left: { sm: '40%', md: '21%' } }}>
                                            <img src={bee2} alt="Second decorative bee icon" srcSet="" />
                                        </Box>
                                        <Box sx={{ position: 'absolute', top: { sm: '6%', md: '6%' }, left: { sm: '14%', md: '7%' } }}>
                                            <img src={bee3} alt="Third decorative bee icon" srcSet="" />
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Container>
                </Box>

                <Box sx={{ marginTop: '70px' }}>
                    <Container maxWidth="xl" sx={{}}>
                        <Grid container xs={12}>
                            <Box sx={{ flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center', display: 'flex' }}>
                                <Grid xs={12} md={6} sx={{ padding: { xs: '20px 24px 0px 24px', md: '70px 70px 0px 90px' } }}>
                                    <Box sx={{}}>
                                        <h1 sx={{ fontSize: { xs: '28px', sm: '45px', md: '45px', lg: '54px' }, marginBottom: '17px', fontWeight: '500', display: 'inline-block', fontFamily: "Rammetto One, sans-serif", color: '#BBFCE9', WebkitTextStroke: '1px #272727', userSelect: 'none' }}>What's new?</h1>
                                    </Box>
                                    <Box>
                                        <Grid xs={12}>
                                            <p sx={{ fontSize: { xs: '12px', sm: '16px', md: '14px', lg: '16px' } }}>
                                                Exciting news! Premium icons are now free for all users! Explore our latest collection of meticulously crafted icons designed to elevate your projects. Unlock creativity with our diverse range of high-quality icons. Upgrade your designs effortlessly with us!
                                            </p>
                                            <p sx={{ marginTop: '25px', fontSize: { xs: '12px', sm: '16px', md: '14px', lg: '16px' } }}>
                                                We're thrilled to announce updates to our icon website! Explore new icons across categories and enjoy an improved user interface with enhanced navigation and faster performance. Discover the perfect icons for your projects with ease. Stay tuned for more updates as we strive to provide the best selection and user experience possible.
                                            </p>
                                        </Grid>
                                    </Box>
                                </Grid>
                                <Grid xs={6} sx={{ paddingLeft: '100px', margin: { xs: '0px 0px -6px 0px', sm: '0px 0px -7px 0px', md: '0px 0px -65px 0px', lg: '0px 0px -7px 0px' } }}>
                                    <img src={boy} alt="Illustration of a boy carrying a phone" width={'100%'} srcSet="" />
                                </Grid>
                            </Box>
                        </Grid>
                    </Container>
                </Box>
            </Box >

        </>
    )
}

export default WebBody